// Copyright (c) 2026 Finerty Data Ltd. All rights reserved.
//
// This file is part of proprietary software owned by Finerty Data Ltd.
// It is confidential and may not be copied, distributed, modified, or used,
// in whole or in part, without the prior written consent of Finerty Data Ltd.
//
// Author: Ahmed Hosny

export enum PolicySignatoryStatus {
  DRAFT = 'DRAFT',
  PENDING_REVIEW = 'PENDING_REVIEW',
  CONFIRMED = 'CONFIRMED',
  PENDING_SIGNATURE = 'PENDING_SIGNATURE',
  SIGNED = 'SIGNED',
  FLAGGED = 'FLAGGED',
  EXCLUDED = 'EXCLUDED'
}

export interface SignatoryStatusSummaryDTO {
  total: number;
  draft: number;
  pendingReview: number;
  confirmed: number;
  pendingSignature: number;
  signed: number;
  flagged: number;
  excluded: number;
}

export interface SignatoryStatusUpdateRequest {
  status: string;
  reason?: string;
}

export interface SignatoryStatusUpdateResult {
  signatoryId: string;
  policyId: string;
  clientProfileId: string;
  signatoryStatus: string;
  previousStatus: string;
  reason?: string;
  statusChangedAt: string;
  statusChangedBy: string;
  visibilityChanged: boolean;
}

export interface BulkPublishRequest {
  clientId?: string;
}

export interface BulkOperationResult {
  total: number;
  succeeded: number;
  failed: number;
  skipped: number;
  details: string[];
}

export interface ResolveFlagRequest {
  resolutionNote: string;
}

export interface RePublishRequest {
  reason?: string;
}
